import { casesSummary } from './types';

export const requestCasesSummary = (promise) => ({
  type: casesSummary.request,
  promise,
});

export const requestCasesSummarySuccess = (response) => ({
  type: casesSummary.success,
  response,
});

export const requestCasesSummaryFailure = (error) => ({
  type: casesSummary.failure,
  error,
});
